import {RESPONSIBLE_GAMBLING_URL} from 'Setup/urls';

export const SELF_ASSESSMENT_URL = `${RESPONSIBLE_GAMBLING_URL}/self-assessment`;
export const SELF_ASSESSMENT_START_URL = `${SELF_ASSESSMENT_URL}/start`;

export const AFFORDABILITY_CALCULATOR_URL = `${RESPONSIBLE_GAMBLING_URL}/affordability-calculator`;
export const AFFORDABILITY_CALCULATOR_START_URL = `${AFFORDABILITY_CALCULATOR_URL}/start`;

export const SESSION_REMINDER_URL = `${RESPONSIBLE_GAMBLING_URL}/session-reminder`;
export const SESSION_REMINDER_UPDATE_URL = `${SESSION_REMINDER_URL}/update`;

export const FINANCIAL_LIMITS_URL = `${RESPONSIBLE_GAMBLING_URL}/financial-limits`;

// The limit periods the account object reports on. Shared so the store and the hooks agree on
// exactly which keys make up a player's limit setup.
export const DEPOSIT_LIMIT_PERIODS = ["dailyDeposit", "weeklyDeposit", "monthlyDeposit"];
export const NET_DEPOSIT_LIMIT_PERIODS = ["dailyNetDeposit", "weeklyNetDeposit", "monthlyNetDeposit"];
export const LIMIT_PERIODS = [...DEPOSIT_LIMIT_PERIODS, ...NET_DEPOSIT_LIMIT_PERIODS];

export const DEPOSIT_LIMITS_URL = `${RESPONSIBLE_GAMBLING_URL}/deposit-limits`;
export const DEPOSIT_LIMITS_UPDATE_URL = `${DEPOSIT_LIMITS_URL}/update`;

export const NET_DEPOSIT_LIMITS_URL = `${RESPONSIBLE_GAMBLING_URL}/net-deposit-limits`;
export const NET_DEPOSIT_LIMITS_UPDATE_URL = `${NET_DEPOSIT_LIMITS_URL}/update`;

export const LOSS_LIMITS_URL = `${RESPONSIBLE_GAMBLING_URL}/loss-limits`;
export const LOSS_LIMITS_UPDATE_URL = `${LOSS_LIMITS_URL}/update`;

export const STAKE_LIMITS_URL = `${RESPONSIBLE_GAMBLING_URL}/stake-limits`;
export const STAKE_LIMITS_UPDATE_URL = `${STAKE_LIMITS_URL}/update`;

export const TAKE_A_BREAK_URL = `${RESPONSIBLE_GAMBLING_URL}/take-a-break`;
export const TAKE_A_BREAK_UPDATE_URL = `${TAKE_A_BREAK_URL}/update`;

export const CLOSE_ACCOUNT_URL = `${RESPONSIBLE_GAMBLING_URL}/close-account`;
export const CLOSE_ACCOUNT_UPDATE_URL = `${CLOSE_ACCOUNT_URL}/update`;

export const SELF_EXCLUSION_URL = `${RESPONSIBLE_GAMBLING_URL}/self-exclusion`;
export const SELF_EXCLUSION_UPDATE_URL = `${SELF_EXCLUSION_URL}/update`;
export const SELF_EXCLUSION_UPDATE_ACROSS_GROUP_URL = `${SELF_EXCLUSION_URL}/update-group`;
